//#region src/nodey-graph-templates/camera-look-gen.ts
var e = (e) => ({
	options: {},
	connections: [
		{
			outputNodeId: "ca6f99b2-d820-4003-8e96-31dee3ac4517",
			outputName: "image_data",
			inputNodeId: "3981824e-1502-462a-90c8-e96a8129f207",
			inputName: "image1",
			isEnabled: !0,
			type: "image"
		},
		{
			inputNodeId: "8f7b859f-123f-416f-aa51-02d1a19f4ebc",
			outputNodeId: "3981824e-1502-462a-90c8-e96a8129f207",
			inputName: "image_data",
			outputName: "generated_image",
			isEnabled: !0,
			type: "image"
		},
		{
			outputNodeId: "22abfe32-7d55-4dda-99bb-694062a6f51d",
			outputName: "text_data",
			inputNodeId: "3981824e-1502-462a-90c8-e96a8129f207",
			inputName: "prompt",
			isEnabled: !0,
			type: "string"
		},
		{
			inputNodeId: "1848518d-22e4-43c3-98b4-a8f245533e71",
			outputNodeId: "3981824e-1502-462a-90c8-e96a8129f207",
			inputName: "image_data",
			outputName: "generated_image",
			isEnabled: !0,
			type: "image"
		}
	],
	frames: [],
	nodes: {
		"ca6f99b2-d820-4003-8e96-31dee3ac4517": {
			id: "ca6f99b2-d820-4003-8e96-31dee3ac4517",
			type: "cinematic-camera",
			customName: "Cinematic Camera",
			position: {
				x: -26.51260872999172,
				y: 215.22025517785553
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: e.cinematicCameraComponent ? { camera_id: {
					defined: !0,
					source: { kind: "local" },
					value: e.cinematicCameraComponent.getUniqueId()
				} } : {},
				outputs: {}
			}
		},
		"8f7b859f-123f-416f-aa51-02d1a19f4ebc": {
			id: "8f7b859f-123f-416f-aa51-02d1a19f4ebc",
			type: "io-image-asset-save",
			customName: "Save OKO Image Asset",
			position: {
				x: 680.4753012850846,
				y: 20.041607063515805
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: {},
				outputs: {}
			}
		},
		"3981824e-1502-462a-90c8-e96a8129f207": {
			id: "3981824e-1502-462a-90c8-e96a8129f207",
			type: "gemini-flash2-5-image",
			customName: "Gemini Flash2.5 Image",
			position: {
				x: 323.49240821320717,
				y: 123.11568678543014
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: {},
				outputs: {}
			}
		},
		"22abfe32-7d55-4dda-99bb-694062a6f51d": {
			id: "22abfe32-7d55-4dda-99bb-694062a6f51d",
			type: "const-string",
			customName: "Text",
			position: {
				x: -27.325193941226985,
				y: 6.0525989990337585
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: {},
				outputs: {}
			}
		},
		"1848518d-22e4-43c3-98b4-a8f245533e71": {
			id: "1848518d-22e4-43c3-98b4-a8f245533e71",
			type: "io-image-save",
			customName: "Save Image",
			position: {
				x: 673.9660578360715,
				y: 280.9805014341757
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: {},
				outputs: {}
			}
		}
	}
});
//#endregion
export { e as cameraLookGenNodeyTemplate };
